import { render, staticRenderFns } from "./EditableAddress.vue?vue&type=template&id=54535a40&scoped=true&"
import script from "./EditableAddress.vue?vue&type=script&lang=js&"
export * from "./EditableAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54535a40",
  null
  
)

export default component.exports